import { atomWithStorage } from 'jotai/utils';

import { storage } from '@service-initiation/shared-utils-jotai';

import { type RemoteTech } from '../types';

export const remoteTechAtom = atomWithStorage<RemoteTech | undefined>(
  'si-tec-car-remote-tech',
  undefined,
  storage<RemoteTech | undefined>(),
  {
    getOnInit: true,
  }
);
